import { MIN_PASSWORD_LENGTH } from '@griply/utils';
import * as yup from 'yup';

export type CompleteSignupData = {
  name: string;
  password: string;
};

export const validationSchema: yup.ObjectSchema<CompleteSignupData> =
  yup.object({
    name: yup.string().required(),
    password: yup.string().required().min(MIN_PASSWORD_LENGTH),
  });

export type CompleteSignupFormFields = yup.InferType<typeof validationSchema>;
